var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5482_3777",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5482_3777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7495 14.25V15.5C10.7495 15.8472 10.8713 16.1424 11.115 16.3854C11.3586 16.6285 11.6544 16.75 12.0025 16.75C12.3505 16.75 12.6453 16.6285 12.887 16.3854C13.1287 16.1424 13.2495 15.8472 13.2495 15.5V14.25H14.4995C14.8467 14.25 15.1419 14.1282 15.3849 13.8846C15.628 13.6409 15.7495 13.3451 15.7495 12.9971C15.7495 12.649 15.628 12.3542 15.3849 12.1125C15.1419 11.8708 14.8467 11.75 14.4995 11.75H13.2495V10.5C13.2495 10.1528 13.1277 9.85764 12.8841 9.61458C12.6404 9.37153 12.3446 9.25 11.9966 9.25C11.6485 9.25 11.3537 9.37153 11.112 9.61458C10.8703 9.85764 10.7495 10.1528 10.7495 10.5V11.75H9.49951C9.1523 11.75 8.85715 11.8718 8.61409 12.1155C8.37104 12.3591 8.24951 12.6549 8.24951 13.003C8.24951 13.351 8.37104 13.6458 8.61409 13.8875C8.85715 14.1292 9.1523 14.25 9.49951 14.25H10.7495ZM5.49951 21C5.08701 21 4.73389 20.8531 4.44014 20.5594C4.14639 20.2656 3.99951 19.9125 3.99951 19.5V9.75C3.99951 9.5125 4.05264 9.2875 4.15889 9.075C4.26514 8.8625 4.41201 8.6875 4.59951 8.55L11.0995 3.675C11.3608 3.475 11.6595 3.375 11.9955 3.375C12.3315 3.375 12.6328 3.475 12.8995 3.675L19.3995 8.55C19.587 8.6875 19.7339 8.8625 19.8401 9.075C19.9464 9.2875 19.9995 9.5125 19.9995 9.75V19.5C19.9995 19.9125 19.8526 20.2656 19.5589 20.5594C19.2651 20.8531 18.912 21 18.4995 21H5.49951ZM5.49951 19.5H18.4995V9.65L11.9995 4.925L5.49951 9.65V19.5Z",
    fill: "#A5B1C0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHealth);
export default __webpack_public_path__ + "static/media/home-health.de5073ffc403e078d4e9c31a2aec2af5.svg";
export { ForwardRef as ReactComponent };